import React from "react";
import { NewModal } from "../uiMerge/newModal";
import CancelModal from "../../assets/wallet/cancel-filter.png";
import Button from "../uiMerge/newButton";
import { Field, Form, Formik } from "formik";
import { Select } from "antd";
import { SelectField } from "../../modules/shared/SelectField";
// import { CheckboxField } from "../shared/CheckboxField";
 
interface Props {
  isOpen: boolean;
  onClose: () => void;
  setIsOpen: Function;
  setFilterByType: (arg:string) => void;
  setFilterByCommunity: (arg:string) => void;
  setFilterByLocationId: (arg:string) => void;
  setEndingSoon: (arg:boolean) => void;
  locations: any;
  locationLoading: boolean
  resetLocationFilter: () => void;
  communities: any;
}
 
const { Option } = Select;
const offerTypes = ["Freebie", "Voucher", "Referral", "Exclusive", "Giveaway"
  // , "Cashback", "Discount"
];
 
export const LocationFilterModal: React.FC<Props> = ({
  isOpen,
  onClose,
  setIsOpen,
  setFilterByType,
  locations,
  resetLocationFilter,
  setFilterByLocationId,
  setFilterByCommunity,
  setEndingSoon,
  communities
}) => {
  const [isChecked, setIsChecked] = React.useState<boolean>(false);
  const [formValues, setFormValues] = React.useState({
    locationId: "",
    offerType: "",
    communityId: "",
  });
  const emptyFormValues = {
    locationId: "",
    offerType: "",
    communityId: "",
  };
  const handleSubmit = (values: {
    locationId: string;
    offerType: string;
    communityId: string;
  }) => {
    setFormValues(values);
    setFilterByLocationId(values.locationId);
    setFilterByType(values.offerType);
    setEndingSoon(isChecked);
    setFilterByCommunity(values.communityId)
    setIsOpen(false);
  };
 
  return (
    <NewModal
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      position="end"
      colorClass="bg-black"
      animationClass="grow-in"
      showCloseButton={false}
    >
      <Formik
        initialValues={formValues}
        onSubmit={handleSubmit}
      >
        {({ resetForm }) => (
        <Form className="w-full px-2 mt-12 mb-8">
          <div className="flex justify-between items-center mt-6 px-4">
            <p className="text-white text-[20px] font-semibold">Filter by</p>
            <div onClick={onClose} className="bg-[#1E1E1E] flex justify-center items-center w-8 h-8 rounded-full cursor-pointer">
              <img src={CancelModal} alt="filter" width={14} height={14} />
            </div>
          </div>
 
          <div className="flex flex-col px-4 mt-6">
            <Field
            name="locationId"
            component={SelectField}
            placeholder="Location">
              <Option value="" disabled>
                Location
              </Option>
              {locations
                .slice()
                .sort((a: any, b: any) => a.city.localeCompare(b.city))
                .map((location: any) => (
                  <Option key={location.id} value={location.id}>
                    {location.city}
                  </Option>
                ))}
            </Field>
 
            <Field
            name="offerType"
            component={SelectField}
            placeholder="Offer Type">
              <Option value="" disabled>
                Offer Type
              </Option>
              {offerTypes.map((o) => (
                <Option key={o} value={o}>
                  {o}
                </Option>
              ))}
            </Field>
 
            <Field
              name="communityId"
              component={SelectField}
              placeholder="Communities"
              className="bg-gray-800 text-white border border-gray-600 rounded-lg p-2 appearance-none focus:outline-none"
            >
              <Option value="" disabled>
                Communities
              </Option>
              {communities
                .filter((c: any) => c?.community?.id)
                .map((c: any) => (
                  <Option key={c.community.id} value={c.community.id}>
                    {c.community.alias}
                  </Option>
                ))}
            </Field>
 
            <div className="flex items-center justify-between cursor-pointer">
              <p className="text-[16px] font-light text-white">Expiring Soon </p>
 
              <input
                onChange={() => setIsChecked(!isChecked)}
                type="checkbox"
                name="expiryDate"
                value="isChecked"
                checked={isChecked}
                className="h-4 w-4 text-white border-gray-300 focus:ring-white cursor-pointer"
              />
            </div>
          </div>
 
          {/* Action Buttons */}
          <div className="flex gap-3 p-4 mt-10">
            <Button
              onClick={() => {
                resetLocationFilter();
                setIsChecked(false);
                setFormValues(emptyFormValues);
                resetForm({ values: emptyFormValues });
              }}
              variant="outline"
              className="w-1/2 border border-white rounded-lg py-2 text-white text-[12px]"
            >
              Reset
            </Button>
 
            <Button
            type="submit"
            className="w-1/2 rounded-lg py-2 text-[12px] text-white bg-gradient-to-r from-[#0045E9] to-[#A151F9]">
              Apply
            </Button>
          </div>
        </Form>
        )}
      </Formik>
    </NewModal>
  );
};
